import * as Yup from 'yup';
import { getValidationRules } from '../../../../validation';
import { RequestQuoteInitialValues } from '../../SolarContact.types';
// @ts-ignore
import stepOne from './meta/stepOne.json';
// @ts-ignore
import stepOneBattery from './meta/stepOne_battery.json';
// @ts-ignore
import stepTwo from './meta/stepTwo.json';
import { Validation } from './RequestQuoteWizard.types';


export const initialValues: RequestQuoteInitialValues = {
  productType: "SOLAR",
  address: '',
  unit: "",
  streetNumber: "",
  streetName: "",
  suburb: "",
  state: "",
  postcode: "",
  hiddenPostcode: "true",
  propertyType: undefined,
  roofType: undefined,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  roofPitch: undefined,
  averageQuarterlyBillCost: '',
  usagePercentDuringDay: '',
  propertyStorey: undefined,
  powerConnectionPhaseType: undefined,
  calculatorValues: {}
};

export const steps = {
  stepOne,
  stepTwo
};

export const validation: Validation[] = [
  {
    STEP_1: Yup.object().shape({
      ...getValidationRules(stepOne)
    }),
    STEP_2: Yup.object().shape({
      ...getValidationRules(stepTwo)
    })
  },
  {
    STEP_1: Yup.object().shape({
      ...getValidationRules(stepOneBattery)
    }),
    STEP_2: Yup.object().shape({
      ...getValidationRules(stepTwo)
    })
  }
];
